import {
  ADMINISTRATOR_ROLE_ID,
  KDAS_ADMIN_ROLE_ID,
  USERS_ADMIN_ROLE_ID,
  UserTypeValues,
} from './../shared/constants';
import { observable, action, configure, computed } from 'mobx';

import { decodeJwtToken, type UserRolesIds } from 'shared-pages/shared/jwt';
import { AppStore } from './app-store';

configure({ enforceActions: 'always' }); // strict mode

/*
  User Authorizations i.e. permissions
*/

// *    --- Store Class ---
//
export class AuthStore {
  appStore: AppStore;
  constructor(appStore: AppStore) {
    this.appStore = appStore;
  }

  @computed get userId(): number {
    const jwt = decodeJwtToken(this.appStore.userLogin.jwt);
    return jwt.userId;
  }

  @computed get userRolesIds(): UserRolesIds[] {
    const jwt = decodeJwtToken(this.appStore.userLogin.jwt);
    return jwt.userRolesIds;
  }

  getUserPermissions = (roleId: number): UserRolesIds | null => {
    const permissions = this.userRolesIds.filter((values) => values.userroleId === roleId);
    if (!permissions || permissions.length === 0) return null;
    else return permissions[0];
  };

  // Διαχειριστής Εφαρμογής
  @computed get isSysAdmin(): boolean {
    const userPerm = this.getUserPermissions(ADMINISTRATOR_ROLE_ID);
    return userPerm !== null;
  }

  // Διαχειριστής Χρηστών και Ρόλων
  @computed get isUsersAdmin(): boolean {
    const userPerm = this.getUserPermissions(USERS_ADMIN_ROLE_ID);
    return userPerm !== null;
  }

  // User type is afis
  @computed get isPlatforOwner(): boolean {
    const jwt = decodeJwtToken(this.appStore.userLogin.jwt);
    return jwt?.userTypeId === UserTypeValues.PlatformOwner;
  }
  // User type is collector
  @computed get isCollector(): boolean {
    const jwt = decodeJwtToken(this.appStore.userLogin.jwt);
    return jwt?.userTypeId === UserTypeValues.Collector;
  }
  // User type is collector driver
  @computed get isCollectorDriver(): boolean {
    const jwt = decodeJwtToken(this.appStore.userLogin.jwt);
    return jwt?.userTypeId === UserTypeValues.CollectorDriver;
  }
  // User type is contributor
  @computed get isContributor(): boolean {
    const jwt = decodeJwtToken(this.appStore.userLogin.jwt);
    return jwt?.userTypeId === UserTypeValues.Contributor;
  }
  // User type is collection point
  @computed get isCollectionPoint(): boolean {
    const jwt = decodeJwtToken(this.appStore.userLogin.jwt);
    return jwt?.userTypeId === UserTypeValues.CollectionPoint;
  }
  // User type is ministry
  @computed get isMinistry(): boolean {
    const jwt = decodeJwtToken(this.appStore.userLogin.jwt);
    return jwt?.userTypeId === UserTypeValues.Ministry;
  }
  // User type is wastereceptionpoint
  @computed get isWasteReception(): boolean {
    const jwt = decodeJwtToken(this.appStore.userLogin.jwt);
    return jwt?.userTypeId === UserTypeValues.WasteReceptionPoint;
  }

  @observable accessor initialized = false;
}
